import { bindActionCreators, compose } from 'redux';
import { connect } from '../../../../common/react-redux';
import { SIDEBAR_ITEM_REF } from '@instructure/quiz-common';
import { DropTargetCreator } from '../../../../common/components/shared/drag_and_drop/dragAndDropUtils';
import { newHoverPosition as newHoverPositionAction } from '../../../../common/actions/dragAndDrop';
import { screenreaderNotification as screenreaderNotificationAction } from '../../../../common/actions/alerts';
import { set as setUI } from '../../../../common/actions/ui';
import { openMoveImmutableModal } from '../../../../common/actions/modal';
import { toggleSidebar as toggleSidebarAction } from '../../../../common/actions/sidebar';
import { scrollToItem as scrollToItemAction } from '../../../../common/actions/scrolling';
import { moveQuizEntry as moveQuizEntryAction } from '../../../api/quizEntries';
import { moveTemporaryQuizEntry as moveTemporaryQuizEntryAction } from '../../../../common/actions/modifications';
import { getActiveQuiz, getTotalPointsPossible } from '../../../../common/selectors/quizzes';
import Sidebar from './presenter';
export var mapStateToProps = function mapStateToProps(state, props) {
  var activeQuiz = getActiveQuiz(state);
  var workingQuizEntriesIncludingTemp = activeQuiz.getWorkingQuizEntries();
  var totalPointsPossible = getTotalPointsPossible(state, activeQuiz.id);
  return {
    dndPositionObj: state.get('dragAndDrop'),
    // for DnD
    quizEntries: workingQuizEntriesIncludingTemp,
    sidebarOpen: props.sidebarOpen || state.getIn(['sidebar', 'isOpen']),
    quizId: activeQuiz.id,
    // for DnD
    totalPointsPossible: totalPointsPossible
  };
};
export var mapDispatchToProps = function mapDispatchToProps(dispatch, props) {
  return {
    toggleSidebar: props.toggleSidebar || bindActionCreators(toggleSidebarAction, dispatch),
    moveTemporaryQuizEntry: bindActionCreators(moveTemporaryQuizEntryAction, dispatch),
    // for DnD
    moveQuizEntry: bindActionCreators(moveQuizEntryAction, dispatch),
    // for DnD
    newHoverPosition: bindActionCreators(newHoverPositionAction, dispatch),
    // for DnD
    openMoveImmutableModal: bindActionCreators(openMoveImmutableModal, dispatch),
    // for DnD
    scrollToItem: props.scrollToItem || bindActionCreators(scrollToItemAction, dispatch),
    screenreaderNotification: bindActionCreators(screenreaderNotificationAction, dispatch),
    setUi: bindActionCreators(setUI, dispatch) // for DnD
  };
};

// Sidebar is a dropTarget to handle drops that occur on the sidebar,
// but not directly on a sidebarItem (such as at the top or bottom).
// it also uses the isOver prop to conditionally render dropZones on Build vs Sidebar
export var BuildingSidebar = compose(connect(mapStateToProps, mapDispatchToProps), DropTargetCreator(SIDEBAR_ITEM_REF))(Sidebar);
export default BuildingSidebar;